import { ValidationSet } from '../../../types/validation';
import { isVariableRegex } from './is-variable-rules';

export const isJsonRules: ValidationSet = {
  condition: (value: string) => /{|}/.test(value),
  rules: [
    {
      message: 'The text entered is not a valid JSON string.',
      test: (value: string) => {
        if (isVariableRegex.test(value.trim())) {
          return false;
        }
        try {
          JSON.parse(value.trim());
          return false;
        } catch (_) {
          return true;
        }
      }
    }
  ]
};
